import { createSlice } from '@reduxjs/toolkit';
import { UserManager } from '../../../@types/user/user';
import { dispatch } from '../../store';
import { _userList } from '../../../_mock';

function objFromArray(array: any[], key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

type UserDetailsState = {
  isLoading: boolean,
  error: Error | string | null;
  userToEdit: UserManager | null,
};

const initialState: UserDetailsState = {
  isLoading: true,
  error: null,
  userToEdit: null,
};

const slice = createSlice({
  name: 'userDetails',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getUserToEditSuccess(state, action) {
      state.isLoading = false;
      state.userToEdit = action.payload;
    }
  },
});

export default slice.reducer;

export function getUserToEdit(id: string) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const user = _userList.filter((_user) => _user.id === id)
      await new Promise((resolve) => setTimeout(resolve, 500));
      dispatch(slice.actions.getUserToEditSuccess(user[0]));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
